/**
 * Converts an array of keys and a value into an object
 * @param  {array}  keys  keys for the object, in order from deepest to least
 * @param  {any}    value value
 * @return {object}       output object
 */
export default function buildObject(keys = [], value = '') {
  // This mutation is not ideal, but it's much shorter than the alternative
  const key = keys.shift();
  if (!key) {
    return {};
  }
  if (0 === keys.length) {
    return { [decodeURIComponent(key)]: value };
  }
  return buildObject(keys, { [decodeURIComponent(key)]: value });
}



// WEBPACK FOOTER //
// ./app/utils/object/buildObject.js